import { ConfigSection } from './components/ConfigSection/ConfigSection.tsx';
import { HistorySection } from './components/HistorySection/HistorySection.tsx';

import { BasePage } from '#src/components/BasePage/BasePage.tsx';
import type { Breadcrumb } from '#src/components/Breadcrumbs/Breadcrumbs.tsx';

export const NotificationsPage = ({
  breadcrumbs,
}: {
  breadcrumbs: Breadcrumb[];
}) => (
  <BasePage title="Notifications" breadcrumbs={breadcrumbs}>
    <ConfigSection />
    <HistorySection />
  </BasePage>
);
